// extracted by mini-css-extract-plugin
export var productImage = "_pa-1";
export var viewLink = "_pa-2";
export var wishlistItem = "_pa-0";